




















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import "@/assets/css/split.css";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateDataPush from "./createdatapush.vue";
import EditDataPush from "./editdatapush.vue";
import CopyDataPush from "./copydatapush.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageUserRequest extends PageRequest {
    keyword: string;
    areaId: number;
}

@Component({
    components: { CreateDataPush, EditDataPush, CopyDataPush },
})
export default class DataPush extends AbpBase {
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    edit() {
        this.editModalShow = true;
    }
    copy() {
        this.copyModalShow = true;
    }
    pagerequest: PageUserRequest = new PageUserRequest();
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    copyModalShow: boolean = false;
    splitnum: number = 0.15;
    searchName: string = ""; //树形搜索名称
    areaTree: any[] = [];
    areaTreeList: any[] = [];

    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.areaTree = this.areaTreeList;
            return;
        }
        const rebuildData = (value, treeList) => {
            let newarr = [];
            treeList.forEach((element) => {
                if (element.children && element.children.length) {
                    if (element.title.indexOf(value) > -1) {
                        element.expand = true;
                        newarr.push(element);
                    }
                    const ab = rebuildData(value, element.children);
                    const obj = {
                        ...element,
                        expand: true,
                        children: ab,
                    };
                    if (ab && ab.length) {
                        newarr.push(obj);
                    }
                } else {
                    if (element.title.indexOf(value) > -1) {
                        newarr.push(element);
                    }
                }
            });
            return newarr;
        };
        this.areaTree = [];
        this.areaTree = rebuildData(value, this.areaTreeList);
    }
    get list() {
        return this.$store.state.datapush.list;
    }
    //选择节点
    getAreaId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.areaId = item[0].id;
        }
        this.$store.commit("datapush/setCurrentPage", 1);
        this.getpage();
    }
    pageChange(page: number) {
        this.$store.commit("datapush/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("datapush/setPageSize", pagesize);
        this.getpage();
    }
    getSearch() {
        this.$store.commit("datapush/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "datapush/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.datapush.pageSize;
    }
    get totalCount() {
        return this.$store.state.datapush.totalCount;
    }
    get currentPage() {
        return this.$store.state.datapush.currentPage;
    }
    //区域
    async getAreaTree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.areaTree = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    get loading() {
        return this.$store.state.area.loading;
    }
    create() {
        this.createModalShow = true;
    }
    //获取上级名称
    getAreaName(areaId: number) {
        this.areaTreeList.forEach((ele) => {
            if (ele.id == areaId) {
                return ele.title;
            }
            if (ele.children != null && ele.children.length > 0) {
                this.getAreaName(areaId);
            }
        })
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            fixed: "left",
            title: this.L("IndexNo"),
        },
        {
            title: this.L("Name"),
            key: "name",
            fixed: "left",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.name },
                        },
                        params.row.name
                    ),
                ]);
            },
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 130,
            sortId: 5,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].displayName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].displayName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Areas"),
            key: "areaId",
            width: 160,
            sortable: true,
            sortId: 3,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("IsEnable"),
            key: "isEnable",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
                );
            },
        },
        {
            title: this.L("ReadData"),
            key: "readData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.readData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("MonitorData"),
            key: "monitorData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.monitorData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("FreezeData"),
            key: "freezeData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.freezeData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("CycleData"),
            key: "cycleData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.cycleData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("HourCycleData"),
            key: "hourUseCycleData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.hourUseCycleData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("PushUrl"),
            key: "url",
            width: 260,
        },
        {
            title: "Id",
            key: "id",
            width: 130,
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 190,
            fixed: "right",
            render: (h: any, params: any) => {
                let del = this.checkButtonAuth('datapushDel');
                let edit = this.checkButtonAuth('datapushEdit');
                let copy = this.checkButtonAuth('datapushCopy');
                return h("div", [
                    edit ? h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.$store.commit("datapush/edit", params.row);
                                    this.edit();
                                },
                            },
                        },
                        this.L("Edit")
                    ) : '',
                    copy ? h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: async () => {
                                    this.$store.commit("datapush/edit", params.row);
                                    this.copy();
                                },
                            },
                        },
                        this.L("Copy")
                    ) : '',
                    del ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "datapush/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        await this.getAreaTree();
        await this.getpage();
    }
}
